import React from 'react';

import { FLAG } from 'Utilities/analytics/optimizely/constants';

import { useBinaryExperiment } from 'Containers/app/experiments/useBinaryExperiment';

import CookieWarning from '../misc/CookieWarning/CookieWarning';

import { CookieConsent } from './CookieConsent';

export const CookieConsentExperiment = () => {
  const showConsentBanner = useBinaryExperiment(FLAG.COOKIE_CONSENT_BANNER, {
    triggerExperiment: true,
  });

  return showConsentBanner ? <CookieConsent /> : <CookieWarning />;
};
